import ReportController from './report.controller';

export default class AccommodationReportController extends ReportController
{
	get endpoint() {
		return 'accommodation';
	}

	get title() {
		return 'Accommodation Report';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/accommodation.report.controller.js
 **/